import { testimonials } from "@/mocks/news";

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-12">
          {/* 品牌介绍 */}
          <div className="lg:col-span-6">
            <span className="inline-flex items-center gap-1.5 text-xs font-bold tracking-widest text-primary-600">
              <i className="ri-information-line" /> ABOUT
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              关于最快吃瓜
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              <strong className="text-foreground-900">最快吃瓜</strong>是一份面向全网吃瓜群众的实时热点速报。
              我们相信真正有营养的吃瓜，不是比谁传得快，而是比谁把来龙去脉讲得清。
            </p>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              从"刚刚发生"的第一现场，到"现场直击"的多信源交叉还原，再到"今日新瓜"的真实热度总榜，
              我们用克制而完整的时间线，帮你在碎片信息里快速抓住主线，不遗漏任何关键节点。
            </p>

            <ul className="mt-6 space-y-3">
              {[
                ["ri-shield-check-line", "信源优先", "只采用公开公告、媒体报道与现场画面，高争议内容明确标注待核实。"],
                ["ri-time-line", "宁慢勿错", "宁可晚发一分钟也不搬运无法核实的消息，更新前统一过三道信源核查。"],
                ["ri-heart-line", "不带节奏", "只呈现事实与时间线，不下结论、不煽动对立，把判断权还给你。"],
              ].map(([icon, t, d]) => (
                <li key={t as string} className="flex items-start gap-3 rounded-xl border border-background-200 bg-background-50 p-4">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-800">
                    <i className={(icon as string) + " text-base"} />
                  </span>
                  <div>
                    <p className="font-heading text-sm font-bold text-foreground-950">{t}</p>
                    <p className="mt-1 text-xs leading-5 text-foreground-500">{d}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* 用户口碑 */}
          <div className="lg:col-span-6">
            <div className="rounded-xl border border-primary-200 bg-background-50 p-6 md:p-8">
              <p className="font-heading text-lg font-black text-foreground-950">大家怎么说</p>
              <p className="mt-1 text-xs text-foreground-500">来自评论区与后台的真实留言节选</p>

              <div className="mt-6 space-y-5">
                {testimonials.map((t) => (
                  <figure key={t.name} className="border-l-2 border-accent-400 pl-4">
                    <blockquote className="text-sm leading-7 text-foreground-700">
                      "{t.text}"
                    </blockquote>
                    <figcaption className="mt-2 flex items-center gap-2 text-xs">
                      <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-200 text-secondary-800">
                        <i className="ri-user-smile-line" />
                      </span>
                      <div>
                        <p className="font-bold text-foreground-900">{t.name}</p>
                        <p className="text-foreground-400">{t.role}</p>
                      </div>
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}